import './App.css';
import Main from './components/main/main';
import { LoaderProvider } from './context/loaderContext';

function App(props) {
  return (
    <LoaderProvider>
      <Main />
    </LoaderProvider>
  );
}

export default App;